<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'linkedFindingReport.cardTitle' | t }}</div>
    <div class="detail-page-card-actions">
        @if (showOpenButton && detailsModel) {
            <button class="btn btn-raised" (click)="openFindingReport()">
                <i class="fas fa-external-link-alt"></i>
                <span>{{ 'linkedFindingReport.openBtn' | t }}</span>
            </button>
        }
    </div>
    <div class="detail-page-card-body padded form-group-styling">
        <div class="row">
            @if (detailsModel) {
                <div class="col-xl-6 left-block">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>{{ 'linkedFindingReport.reportNameLabel' | t }}</label>
                                <input
                                    type="text"
                                    [value]="detailsModel.name"
                                    class="form-control form-control-sm"
                                    disabled
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>{{ 'linkedFindingReport.reportTypeLabel' | t }}</label>
                                <input
                                    type="text"
                                    [value]="detailsModel.reportTypeName"
                                    class="form-control form-control-sm"
                                    disabled
                                    inputTooltip
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>{{ 'linkedFindingReport.reportNoLabel' | t }}</label>
                                <input
                                    type="text"
                                    [value]="detailsModel.reportNumber"
                                    class="form-control form-control-sm"
                                    disabled
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>{{ 'linkedFindingReport.overallScoreLabel' | t }}</label>
                                <ng-select
                                    [items]="[
                                        {
                                            value: detailsModel.overallScoreId,
                                            label: detailsModel.overallScoreName,
                                            color: detailsModel.overallScoreColor,
                                        },
                                    ]"
                                    [ngModel]="detailsModel.overallScoreId"
                                    bindValue="value"
                                    disabled
                                >
                                    <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                        <span
                                            class="select-template-color"
                                            [style.background-color]="item.color"
                                        ></span>
                                        {{ item.label }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>{{ 'linkedFindingReport.reportDateLabel' | t }}</label>
                                <date-input
                                    [(value)]="detailsModel.reportDate"
                                    [disabled]="true"
                                ></date-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 right-block">
                    <div class="form-group">
                        <label>{{ 'linkedFindingReport.conclusionLabel' | t }}</label>
                        <textarea
                            type="date"
                            [value]="detailsModel.conclusion"
                            class="form-control form-control-sm"
                            disabled
                            inputTooltip
                        >
                        </textarea>
                    </div>
                </div>
            } @else {
                <div class="fancy-loader submodule"></div>
            }
        </div>
    </div>
</div>
